import { onMounted, onUnmounted } from '@vue/composition-api';
import ClipboardJS from 'clipboard';
export function useClipboard(option) {
  var clipboard;
  onMounted(function () {
    clipboard = new ClipboardJS(option.target, option.clipboardOption).on('success', function () {
      option.successCallback();
    }).on('error', function () {
      option.errorCallback();
    });
  });
  onUnmounted(function () {
    if (clipboard) {
      clipboard.destroy();
    }
  });
}